import { useCallback, useEffect, useRef, useState } from "react";
import axiosInstance from "../../../../../redux/api";

export function useProductList(params) {
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);
  const abortRef = useRef(null);

  const refetch = useCallback(() => setReloadTick((t) => t + 1), []);

  useEffect(() => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    axiosInstance
      .get("admin/products", { params, signal: controller.signal })
      .then((response) => {
        const payload = response?.data?.response;
        setItems(payload?.products || []);
        setPagination(payload?.pagination || {});
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        console.error("Error fetching products:", error);
        setItems([]);
        setPagination({});
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [params, reloadTick]);

  return { items, pagination, loading, refetch };
}
